import client from "../client/client"

const fetchAuthStatus = async () => {
    const baseApiUrl = window.config?.baseApiUrl ?? null
    if (!baseApiUrl) return { isAuth: false, isAdmin: false, isStudent: false, user: null }
    const authRes = await client.get(`${baseApiUrl}/auth/my`);
    const authData = await authRes.json();
    console.log('isAuth response: ' + authData.isAuth);
    const res = await client.get(`${baseApiUrl}/adminapi/claim/setClaims`)
    const data = await res.json();
    console.log("isAdmin response: " + data.isAdmin)
    const user = authData.user || authData.profile || (
      authData.name || authData.given_name || authData.givenName
        ? {
            name: authData.name,
            given_name: authData.given_name || authData.givenName,
            family_name: authData.family_name || authData.familyName,
          }
        : null
    )
    const isStudent = Array.isArray(authData.claims)
      && authData.claims.some((c) => c.type === 'isstudent' && c.value === 'Yes')
    return {
        isAuth: authData.isAuth,
        isAdmin: data.isAdmin,
        isStudent,
        user,
    }
}

const authApi = {
    fetchAuthStatus,
}

export default authApi